module.exports = __webpack_public_path__ + "static/scale-model-of-broken-arrow-historical-soc-in-tulsa-oklahoma-608d300d0fdc316d89bb9edb8e6efe86.png";